"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddressGeoSuggest = void 0;
var _types = require("../../types");
var _getFlatGeoSuggest = require("./getFlatGeoSuggest");
var _getJKGeoSuggest = require("./getJKGeoSuggest");
/* eslint-disable  @typescript-eslint/no-explicit-any */

/**
 * Санк-экшн для запроса геосаджеста при вводе в фильтр адреса
 * В зависимости от типа оцениваемой недвижимости, определяет, какой саджест загружать
 * */
const getAddressGeoSuggest = (addressChunk, targetPage) => async (dispatch, getState) => {
  const {
    filters: {
      estimationTarget
    }
  } = getState();
  switch (estimationTarget) {
    case _types.EEstimationTargets.flat:
    case _types.EEstimationTargets.house:
    case _types.EEstimationTargets.land:
      return dispatch((0, _getFlatGeoSuggest.getFlatGeoSuggest)(addressChunk, targetPage));
    case _types.EEstimationTargets.newbuilding:
      return dispatch((0, _getJKGeoSuggest.getJKGeoSuggest)(addressChunk));
  }
};
exports.getAddressGeoSuggest = getAddressGeoSuggest;